import { render } from "./MyFoot.vue?vue&type=template&id=1e8ca728&scoped=true"
import script from "./MyFoot.vue?vue&type=script&lang=js"
export * from "./MyFoot.vue?vue&type=script&lang=js"

import "./MyFoot.vue?vue&type=style&index=0&id=1e8ca728&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8ca728"]])

export default __exports__